/** app-main `TutorAttendanceRateReason`; labels come from `lists.tutor_attendance_rate.reason`. */
export enum TutorAttendanceRateReason {
  Completed = 'COMPLETED',
  TutorNoShow1stLesson = 'TUTOR_NO_SHOW_1ST_LESSON',
  TutorNoShow = 'TUTOR_NO_SHOW',
  Canceled1stLesson = 'CANCELED_1ST_LESSON',
  Canceled = 'CANCELED',
  CanceledBad1stLesson = 'CANCELED_BAD_1ST_LESSON',
  CanceledBad = 'CANCELED_BAD',
  Rescheduled = 'RESCHEDULED',
  RescheduledBad = 'RESCHEDULED_BAD',
}
